import { Option } from "@jutro/types";
import dayjs, { Dayjs } from "dayjs";
import { atom } from "jotai";
import { searchParamAtom } from "lib/atoms/searchParamAtom";
import {
  VisitArchiveFilters,
  visitsArchiveFiltersOptions,
} from "views/Visits/Archive/tools";

export const visitsArchiveTotalPagesAtom = atom(0);

export const visitsArchiveCurrentPageAtom = searchParamAtom<number>({
  key: "page",
  defaultValue: 1,
  parse: (value) => Number(value),
  serialize: (value) => value.toString(),
});

export const visitsArchiveDateAtom = searchParamAtom<Dayjs>({
  key: "date",
  defaultValue: dayjs().startOf("month"),
  parse: (value) => dayjs(value),
  serialize: (value) => value.format("YYYY-MM-DD"),
  sideEffectOnSet: (_, set, searchParams) => {
    searchParams.delete("page");
    set(visitsArchiveTotalPagesAtom, 0);
  },
});

export const visitsArchiveVojevodshipIdAtom = searchParamAtom<string>({
  key: "vojevodshipId",
  defaultValue: "P",
  sideEffectOnSet: (_, set, searchParams) => {
    searchParams.delete("page");
    set(visitsArchiveTotalPagesAtom, 0);
  },
});

export const visitsArchiveSearchAtom = searchParamAtom<string>({
  key: "search",
  defaultValue: "",
  sideEffectOnSet: (_, set, searchParams) => {
    searchParams.delete("page");
    set(visitsArchiveTotalPagesAtom, 0);
  },
});

export const visitsArchiveFiltersAtom = searchParamAtom<
  Option<VisitArchiveFilters>[]
>({
  key: "filters",
  defaultValue: [],
  parse: (value) =>
    value
      .split(",")
      .map((el) =>
        visitsArchiveFiltersOptions.find(({ value }) => value === el),
      )
      .filter(Boolean) as Option<VisitArchiveFilters>[],
  serialize: (value) => value.map(({ value }) => value).join(","),
  sideEffectOnSet: (_, set, searchParams) => {
    searchParams.delete("page");
    set(visitsArchiveTotalPagesAtom, 0);
  },
});
